<a class="btn" title="Filter Users" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
	<span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</a>

<div bsModal #userFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
	<div class="modal-dialog" style="width:1000px;">
		<div class="modal-content">
			<form (ngSubmit)="applyFilter()">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="applyFilter()">&times;</button>
					<h4 class="modal-title" id="myModalLabel">Filter Users</h4>
				</div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>User Name</label>
                                </div>
                                <input name="UserFilterName" type="text" class="form-control" placeholder="User Name" [(ngModel)]="name" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Permission</label>
                                </div>
                                <select name="selectedPermissions" class="form-control" size="4" multiple="multiple" [(ngModel)]="selectedPermissions">
                                    <option *ngFor="let permission of permissions" [value]="permission.Id">{{ permission.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="employeePermissionIncluded()">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngIf="employeePermissionIncluded()">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Status</label>
                                </div>
                                <div class="btn-group btn-group-justified">
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="allEmployees" [class.btn-warning]="!allEmployees" (click)="allEmployees = !allEmployees">
                                            {{ allEmployees ? 'All' : 'Only Specially Assigned' }} Employees
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Company</label>
                                </div>
                                <select name="selectedCompaniesUserFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedCompanies" (change)="getselectedvalue()">
                                    <!--<select name="selectedCompaniesUserFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedCompanies">-->
                                    <option *ngFor="let company of companies" [value]="company.Id">{{ company.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Minesite</label>
                                </div>
                                <select name="selectedMinesitesUserFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedMinesites">
                                    <option *ngFor="let minesite of filteredMinesites" [value]="minesite.Id">{{ minesite.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <button type="button" class="btn btn-success" *ngIf="companyfilterApplied" (click)="clearCompanyFilter()">Clear Company Selection</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="checkbox">
                                <label><input id="AbleToPrint" name="AbleToPrint" type="checkbox" [(ngModel)]="ableToPrint">Able to Print</label>
                            </div>
                            <div class="checkbox">
                                <label><input id="NotAbleToPrint" name="NotAbleToPrint" type="checkbox" [(ngModel)]="notAbleToPrint">Not Able to Print</label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <hr />
                        </div>
                    </div>
                </div>
				<div class="modal-footer">
					<button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
					<button type="submit" class="btn btn-default">Apply Filter</button>
				</div>
			</form>
		</div>
	</div>
</div>